import AddGreenFilledSVG from "../../../assets/icons/add-icon-green-filled.svg";

export const AddGreenFilled: React.FC = () => {
  return <img src={AddGreenFilledSVG} alt="" className="w-[24px] h-[24px] cursor-pointer" />;
};
